import { c as _c } from "react/compiler-runtime";
import { type ReactElement } from 'react';
import CopilotChartCard, { CopilotChartUnavailable } from 'shared/copilot/components/CopilotChartCard';
import { type CopilotChartData } from 'shared/copilot/charts/types';
interface MarkdownChartTokenProps {
  'data-id'?: string;
  'data-type'?: string;
  chartIdMap?: Map<string, unknown>;
}
const isCopilotChartData = (value: unknown): value is CopilotChartData => typeof value === 'object' && value != null && 'chartType' in value && 'data' in value;
export const MarkdownChartToken = t0 => {
  const $ = _c(7);
  const {
    "data-id": id,
    "data-type": type,
    chartIdMap
  } = t0;
  if (type !== "chart" || id == null || chartIdMap == null) {
    return null;
  }
  let chart;
  let t1;
  if ($[0] !== chartIdMap || $[1] !== id) {
    chart = chartIdMap.get(id);
    t1 = isCopilotChartData(chart);
    $[0] = chartIdMap;
    $[1] = id;
    $[2] = chart;
    $[3] = t1;
  } else {
    chart = $[2];
    t1 = $[3];
  }
  if (!t1) {
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <CopilotChartUnavailable />;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t2;
  if ($[5] !== chart) {
    t2 = <CopilotChartCard chart={chart} />;
    $[5] = chart;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};